import { FC } from 'react';

import { Button } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import { remove } from '@purpur/library/icon/assets/remove';
import Image from 'next/image';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { ProductsCompareProduct } from '@telialt/eshop-comparison/src/models';
import { withParams } from '@telialt/utils/src/helpers';

import {
    ComparedProductCardAction,
    ComparedProductCardContainer,
    ComparedProductCardImageContainer,
    ComparedProductCardProductInfo,
    ComparedProductCardProductName,
} from './ComparedProducts.styles';

type Props = {
    product: ProductsCompareProduct;
    onRemove: () => void;
    url: string;
};

export const ComparedProductCard: FC<Props> = ({ product, onRemove, url }) => {
    const { t } = useTranslations();

    return (
        <ComparedProductCardContainer>
            <ComparedProductCardProductInfo>
                <ComparedProductCardImageContainer>
                    <Image src={product.image} alt="" fill={true} unoptimized={true} />
                </ComparedProductCardImageContainer>
                <ComparedProductCardProductName href={url} target="_blank">
                    {product.name}
                </ComparedProductCardProductName>
            </ComparedProductCardProductInfo>
            <ComparedProductCardAction>
                <Button
                    variant="text"
                    size="sm"
                    onClick={onRemove}
                    aria-label={withParams(t['eshop.category.compare.remove_a11y_label'], {
                        productName: product.name,
                    })}
                >
                    <Icon svg={remove} size="xs" /> {t['eshop.category.compare.remove']}
                </Button>
            </ComparedProductCardAction>
        </ComparedProductCardContainer>
    );
};
